import "core-js/modules/es.object.assign.js";
import { reactive, toRefs, watch, onBeforeMount, onBeforeUnmount, ref } from "vue";
//@ts-ignore
import { useListingTypologyStore } from "@store/ListingTypologyStore";
export var useLTMS = props => {
  var getKey = l => l.listingTypologyId;
  var lts = useListingTypologyStore();
  var state = reactive({
    curGroup: ""
  });
  var activeMacroTypology = ref(null);
  watch(() => lts.typologiesSelected, () => {
    lts.updateSelectedLabel();
  });
  onBeforeMount(() => {
    if (props === null || props === void 0 ? void 0 : props.listingTypologies) lts.initListingTypologyStore(props.listingTypologies);
    /*
    * Opening the accordion for the selected typology (if there is one) and
    * setting the current selected group
    *
    * Preconditions:
    * - All the typologies belong to the same macroTypology (so to the same accordion)
    * */
    if (lts.typologiesSelected.length) {
      var firstTypologySelected = lts.typologiesSelected[0];
      if (!firstTypologySelected.group) return;
      activeMacroTypology.value = lts.typologiesSelected[0];
      lts.macroTypologiesObj[activeMacroTypology.value.macroTypologyID].active = true;
      state.curGroup = lts.macroTypologiesObj[lts.typologiesSelected[0].macroTypologyID].group;
    }
  });
  onBeforeUnmount(() => {
    //Unchecking the macrotypology
    if (activeMacroTypology.value) activeMacroTypology.value.active = false;
  });
  return Object.assign(Object.assign({}, toRefs(state)), {
    getKey
  });
};